import { render, staticRenderFns } from "./BillboardPage.vue?vue&type=template&id=977e966a&scoped=true&"
import script from "./BillboardPage.vue?vue&type=script&lang=ts&"
export * from "./BillboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977e966a",
  null
  
)

export default component.exports